<template>
  <section>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="true"></loading>
    </div>
    <div class="header">
      <span>
        <div class="header-box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <div class="title-text"> Hello, {{ profile.displayName | '' }}</div>
                <div class="title-bold"> Sending Transaction  </div>
              </div>
            </div>
            <div class="media-right">
              <figure class="image is-64x64">
                <img v-if=profile.pictureUrl class="is-rounded" :src=profile.pictureUrl alt="Image">
                <img v-else class="is-rounded" src="https://test.iyawat.com/libra-chatbot/nodejs/images/libra-bg.jpg" alt="img" style="width: 50px;    margin: 0 auto;">
              </figure>
            </div>
          </article>
        </div>
      </span>
    </div>
  <div class="Wallet">
    <section>
      <div class="wallet-body">
        <div v-if="iOS">
          <b-button
            class="button-color btn-1"
            icon-left="qrcode"
            @click="scanQR"
          >
            Click to Scan QR
          </b-button>

        </div>
        <div v-else>
          <qrcode-capture id="file" @decode="onDecode" />
          <label for="file" class="btn-1"> Click to scan QR </label>
        </div>

      </div>

      <div class="button-box">
          <b-button
            icon-left="pencil-alt"
            @click="sendWithManualAddress"
          >
            Send Manually
          </b-button>
	  <br>
          <b-button
            icon-left="arrow-left"
            @click="back"
          >
            Back
          </b-button>
      </div>
    </section>
  </div>
  <FooterBar />
  </section>

</template>

<script>
// require styles
import FooterBar from '@/views/Footer'
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import UserDataPersistance from '@/userData/persistance'
import { mapState, mapActions } from 'vuex'
import { ToastProgrammatic as Toast } from 'buefy'
import { QrcodeCapture } from 'vue-qrcode-reader'

export default {
  name: 'Home',
  components: {
    FooterBar,
    Loading,
    QrcodeCapture
  },
  data: () => ({
    isLoading: true,
    userData: null,
    fetched: false,
    result: '',
    iOS: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    }
  }),
  filters: {
    numberWithCommas (x) {
      if (x !== undefined) {
        let parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.getProfile()
    }, 1000)
    // Load from local storage
    // alert(this.getOS())
    if (this.getOS() === 'iOS') {
      this.scanQR()
      this.iOS = true
    } else {
      this.iOS = false
    }
    this.userData = new UserDataPersistance()
  },
  computed: {
    ...mapState({
      wallet: state => state.wallet
    })
  },
  methods: {
    ...mapActions({
      createWallet: 'createWallet'
    }),
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
        _this.isLoading = false
      }).catch(function (error) {
        Toast.open({
          message: 'Error getting profile: ' + error,
          type: 'is-danger'
        })
      })
    },
    scanQR () {
      let _this = this
      this.$liff.scanCode().then(function (result) {
        const qrString = result.value
        if (qrString.length === 64) {
          _this.$router.push({
            name: 'Send',
            query: {
              to: qrString
            }
          })
        } else if (qrString[0] === '{') {
          const jsonQR = JSON.parse(qrString)
          if (jsonQR.type === 'peer_to_peer_payment') {
            _this.$router.push({
              name: 'Send',
              query: {
                to: jsonQR.address,
                amount: jsonQR.amount,
                editable: false,
                labelHead: 'Pay to',
                labelValue: jsonQR.merchant
              }
            })
          }
        }
      })
    },
    async updatePersistance (userAddress, balance, mnemonic) {
      this.userData.update(userAddress, balance, mnemonic)
      this.userData.save()
    },
    back () {
      this.$router.push({ name: 'Home' })
    },
    sendWithManualAddress () {
      this.$router.push({ name: 'Send' })
    },
    onDecode (result) {
      const qrString = result
      if (qrString.length === 64) {
        this.$router.push({
          name: 'Send',
          query: {
            to: qrString
          }
        })
      } else if (qrString[0] === '{') {
        const jsonQR = JSON.parse(qrString)
        if (jsonQR.type === 'peer_to_peer_payment') {
          this.$router.push({
            name: 'Send',
            query: {
              to: jsonQR.address,
              amount: jsonQR.amount,
              editable: false,
              labelHead: 'Pay to',
              labelValue: jsonQR.merchant
            }
          })
        }
      }
    },
    getOS () {
      var userAgent = navigator.userAgent
      var platform = navigator.platform
      var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
      var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
      var iosPlatforms = ['iPhone', 'iPad', 'iPod']
      var os = null

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS'
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS'
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows'
      } else if (/Android/.test(userAgent)) {
        os = 'Android'
      } else if (!os && /Linux/.test(platform)) {
        os = 'Linux'
      }

      return os
    }
  }
}
</script>

<style lang="scss" scoped>
  main, html, body {
    font-family: 'Prompt', sans-serif;
    overflow-x: none;
    -webkit-overflow-scrolling: touch;
    background-color: #F4F4F4;
  }
  .header {
    overflow:hidden;
  }
  .header-box {
    background-color: rgb(76, 0, 114);
    border-radius: 0;
    padding: 5% 5% 5% 5%;
  }
  .title-bar {
    background-color: rgb(76, 0, 114);
  }
  .title-text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: .5px;
  }
  .title-bold{
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.801);
    letter-spacing: .5px;
  }

[type="file"] {
  height: 0;
  overflow: hidden;
  width: 0;
}

[type="file"] + label {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
    font-family: 'Poppins', sans-serif;
    font-size: inherit;
  font-weight: 600;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;

  &:hover {
    background-color: darken(#f15d22, 10%);
  }

  &.btn-2 {
    background-color: #99c793;
    border-radius: 50px;
    overflow: hidden;

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 100%;
      height: 100%;
      right: 130%;
      line-height: 3.3;
      position: absolute;
      top: 0px;
      transition: all 0.3s;
    }

    &:hover {
      background-color: darken(#99c793, 30%);

      &::before {
        right: 75%;
      }
    }
  }
}

.button-color {
  background: #f15d22;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: 'Poppins', sans-serif;
  font-size: inherit;
  font-weight: 600;
  margin-bottom: 1rem;
  outline: none;
  padding: 1rem 50px;
  padding-bottom: 3rem;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;

  &:hover {
    background-color: darken(#f15d22, 10%);
  }

  &.btn-1 {
    background-color: #f79159;
    box-shadow: 0 6px darken(#f79159, 10%);
    transition: none;

    &:hover {
      box-shadow: 0 4px darken(#f79159, 10%);
      top: 2px;
    }
  }

  &.btn-2 {
    background-color: #99c793;
    border-radius: 50px;
    overflow: hidden;

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 100%;
      height: 100%;
      right: 130%;
      line-height: 3.3;
      position: absolute;
      top: 0px;
      transition: all 0.3s;
    }

    &:hover {
      background-color: darken(#99c793, 30%);

      &::before {
        right: 75%;
      }
    }
  }

  &.btn-3 {
    background-color: #ee6d9e;
    border-radius: 0;
    overflow: hidden;

    span {
      display: inline-block;
      height: 100%;
      transition: all 0.3s;
      width: 100%;
    }

    &::before {
      color: #fff;
      content: "\f382";
      font-family: "Font Awesome 5 Pro";
      font-size: 130%;
      height: 100%;
      left: 0;
      line-height: 2.6;
      position: absolute;
      top: -180%;
      transition: all 0.3s;
      width: 100%;
    }

    &:hover {
      background-color: darken(#ee6d9e, 30%);

      span {
        transform: translateY(300%);
      }

      &::before {
        top: 0;
      }
    }
  }
}

// Demo specific styles below
body {
  background: url('https://benmarshall.me/wp-content/uploads/2018/08/background.gif');
  font-family: 'Lora', serif;
  font-size: 16px;
  line-height: 1.3;
  margin: 1rem 0;
  text-align: center;
}

.wrapper {
  background-color: #fff;
  border-radius: 1rem;
  margin: 0 auto;
  max-width: 500px;
  padding: 2rem;
  width: 100%;
}

.footer {
  font-size: .8rem;
  margin-bottom: 0;
  margin-top: 3rem;
}

h1,
p {
  margin-bottom: 2rem;
}

h1 {
  font-family: 'Poppins', sans-serif;
  font-size: 1.7rem;
}

a {
  color: #31c1ef;
  text-decoration: none;
}
</style>

